export default "__VITE_ASSET__176b0672__"